import React, { useState, useEffect, useContext } from "react";
import moment from "moment";

import Utils, { getWeekInterval } from "../../../../helpers/utils";

import ReflectionHeaderChart from "./ReflectionHeaderChart";
import ReflectionHeaderTable from "./ReflectionHeaderTable";
import ReflectionContext from "../ReflectionContext";

import VIEW_MODES from "./viewModes";
import FORMATS from "./formats";
const DATE_FORMAT = "YYYY-MM-DD";

export default function ReflectionHeaderToggle({
  viewMode,
  days,
  timeline,
  isAutoTrackMode,
  onDateChanged = () => {},
}) {
  const {
    controller,
    showTutorials,
    showReflectionTutorials,
    timeUnit,
    selectedDate: sd,
  } = useContext(ReflectionContext) || {};

  if (!sd) return null;

  const [showBackIcon, setShowBackIcon] = useState(false);
  const [intervalColumns, setIntervalColumns] = useState(null);
  const [selectedTimeUnit, setSelectedTimeUnit] = useState(timeUnit);
  const [selectedDate, setSelectedDate] = useState("");

  useEffect(() => {
    if (!timeUnit || !sd) return;

    const unit = timeUnit === "week" ? "isoweek" : timeUnit;

    const queryDate = sd.endOf(unit);
    const now = Utils.nowUserTz(controller).endOf(unit);
    setShowBackIcon(now.diff(queryDate, `${timeUnit}s`) > 0);

    setSelectedDate(queryDate.clone());
    initIntervals(timeUnit);
  }, [sd, timeUnit]);

  const initIntervals = (tu) => {
    const format = FORMATS[tu]?.format;
    if (!format) return [];

    setIntervalColumns(Object.keys(FORMATS));
  };

  const travelInTime = (offset, isEnabled = true) => {
    if (showTutorials || showReflectionTutorials) return;
    if (!isEnabled) return;

    //  Add 1 week/day/year
    const newDate = selectedDate.clone().add(offset, selectedTimeUnit);

    // Update results
    onDateChanged(newDate.format(DATE_FORMAT), selectedTimeUnit);
  };

  const onPickerValueChanged = (tu) => {
    if (showTutorials || showReflectionTutorials) return;

    setSelectedTimeUnit(tu);
    setShowBackIcon(true);
    const newDate = Utils.nowUserTz(controller).startOf(
      tu === "week" ? "isoWeek" : tu,
    );

    // Update results
    onDateChanged(newDate.format(DATE_FORMAT), tu);
  };

  const TAG =
    viewMode != VIEW_MODES.tableView || isAutoTrackMode
      ? ReflectionHeaderChart
      : ReflectionHeaderTable

  return (
    <TAG
      days={days}
      timeline={timeline}
      intervalColumns={intervalColumns}
      timeUnit={selectedTimeUnit}
      showBackIcon={showBackIcon}
      travelInTime={travelInTime}
      onPickerValueChanged={onPickerValueChanged}
    />
  );
}
